

import Accounts from "./Accounts";


class Company extends Accounts{
    constructor(params) {
      super(params);
    this.locations = [];
    this.accountLabel = "Company";
    this.accountType = "Company";
  this.setParameters(params);
    }
  
    setParameters(params){
      for (var prop in params){
          if (params.hasOwnProperty(prop)){
              var method = "set" + prop.charAt(0).toUpperCase() + prop.slice(1);
              if (this[method]){
                  this[method](params[prop]);
              }
              else{
                this[prop] = params[prop];
              }
              
          }
      }
    }
  
}

export default Company;
  